<template>
  <div class="bill_search_panel">
     <cw_search_input ref="searchInput" :inputProperty="inputProperty" :propertyObject="propertyObject" :label="label">
           <template slot="header">  
                <div> 
                    <el-form ref="baseForm" class="flex">
                        <el-form-item class="bill_search_item"  v-for="(el, index) in formInputs" :key="index" :label="el.label" >
                            <el-input class="bill_search_input"  :value="formData[el.field]"  @input="onInputChange($event,el.field)" ></el-input>
                        </el-form-item>                                                                           
                    </el-form>   
               </div> 
               <div class="search_condition_flex">
                    <span class="btn right_sub_btn search_btn" style="margin-top:5%;margin-right:9%" @click="onSubmitQuery">{{queryLabelName}}</span>
                    <span class="btn right_sub_btn clear_btn" style="margin-top:5%"  @click="onClearCondition">{{clearLabelName}}</span>
                </div>  
           </template>
           <template slot="container">
               <div>
                    <vxe-table
                                border
                                resizable
                                show-overflow
                                ref="searchTable" 
                                :data="tableData"                             
                                :edit-config="{trigger: 'click', mode: 'cell',showStatus: true}">
                            <vxe-table-column   v-for="(config, index) in tableColumns" :key="index" v-bind="config" ></vxe-table-column>
                    </vxe-table>
                    <vxe-pager
                        border
                        size="medium"
                        :current-page="tablePager.currentPage"
                        :page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
                        @page-change="onHandlePageChange">
                    </vxe-pager>
               </div>
           </template>
           <template slot="footer">
              <div class="dialog-footer">
                    <el-button @click="onCancel">{{cancelLabelName}}</el-button>
                    <el-button type="primary" @click.stop="onConfirm">{{confirmLabelName}}</el-button>
              </div>
           </template>
     </cw_search_input>
  </div>    
</template>

<script>
import cw_search_input from 'busicomponent/form/cw_search_input.vue';

export default {
    components:{
        cw_search_input
    },
    props:{
        label:{
            type:String
        },
        inputProperty:{
           type:String,
            default:()=>{
                return 'bill'
            }
        },
        propertyObject:{
            type:Object,
             default:()=>{
                return {
                    bill:'中国加油'
                }
            }
        },
        url:{
            type:String,
            default:()=>{
                return ""
            }
        },
        queryLabelName:{
           type:String,
           default(){
               return '搜索'
           }
        },
        clearLabelName:{
           type:String,
           default(){
               return '清空'
           }
        },
        cancelLabelName:{
            type:String,
            default(){
                return '取 消'
            }
        },
        confirmLabelName:{
           type:String,
           default(){
               return '确 定'
           }
        },       
       initForm:{
            type:Array,
            default:()=>{
               return []
            }
        },
        initTable:{
            type:Array,
            default:()=>{
                return []
            } 
        }
    },
    created(){
        //初始化form面板
       this.initFormPanel();
       this.initTablePanel();
    },
    data(){    
      return {
          formInputs:this.initForm,
          formData:{},
          tableColumns:this.initTable,
          tablePager:{
                currentPage:1,
                pageSize:10,
                totalResult:0
              },
          tableData:[]
      }
    },
    methods:{
        /**
         * 提交搜索
         */
        onSubmitQuery(){
           this.submitQuery();
        },
        /**
         * 处理分页页面更改
         */
        onHandlePageChange({ currentPage, pageSize }){
            this.tablePager.currentPage = currentPage;
            this.tablePager.pageSize = pageSize;
            this.submitQuery();
        },
        /**
         * 清空查询条件
         */
        onClearCondition(){
            this.formData = {}
        },
        /**
         * 关闭窗口
         */
        onCancel(){
           this.closeSearchWindow();  
        },
        /**
         * 点击确定
         */
        onConfirm(){
           //console.log(this.$refs.searchTable);
           //console.log(JSON.stringify(this.$refs.searchTable.getRadioRow()));
           var billInfo=this.$refs.searchTable.getRadioRow();
           this.$parent.$emit("onConfirm",billInfo);
           //this.$emit("onConfirm",billInfo);
        },
        /**
         * 输入值已更改事件
         */
        onInputChange(event,field){          
            this.$set(this.formData,field,event);
            this.formData = Object.assign({},this.formData);
        },
        /**
         * 初始化form查询条件
         */
        initFormPanel(){ 
          if(!this.initForm) return;     
          this.initForm.forEach((item,index)=>{             
              this.formData[item.field]= item.value; 
          });         
        },
        /**
         * 初始化表格列
         */
        initTablePanel(){

        },
        /**
         * 关闭搜索对话框
         */
        closeSearchWindow(){
            this.$refs.searchInput.closeQueryWindow();
        },
        openSearchWindow(){
            this.$refs.searchInput.openQueryWindow();
        },
        /**
         * 提交查询
         */
        async submitQuery(){
            // debugger;
             let searchInfo={
                "page": 1,
	            "pageSize": 100,
             },where=this.formData;
            searchInfo.searchCriteria=where;
            searchInfo.page=this.tablePager.currentPage;
            searchInfo.pageSize=this.tablePager.pageSize;
             
            console.log(JSON.stringify(searchInfo),'====');

            let resResults = await this.$post(this.url,searchInfo);
         
            const { data,msg,msgCode,status,type,code} = resResults;
            if(!status) return false;
            
            // debugger;
            if(data.list){
              this.tableData=data.list;
              this.tablePager.pageSize=data.pageSize;
              this.tablePager.currentPage=1;
              this.tablePager.totalResult=data.total;
            }
        }
    }
}
</script>

<style scoped>
    .bill_search_panel {
        width: 160%;
    }
    /**search_box */
    .search_condition_flex {
      display: flex;
      justify-content : flex-end;
    }

    .bill_search_item{
       display: flex;
       margin-bottom:1px;
       margin-top: 20px
    }
    .bill_search_input{
        height:60px;
    }
    .bill_search_footer{
        text-align: right;	
    }
    .bill_search_footer .el-button{
        padding: 6px 15px;
    }


</style>